import axios from 'axios'
import vue from 'vue'
import router from "../router";

axios.defaults.baseURL = '/jiance';

const request = function (query) {

  return axios.request(query).then(res => {
    //这里判断状态码为退出登录
    if (res.data.returnCode == "20011") {
      router.push('/')
    }
    return Promise.resolve(res.data)
  }).catch(e => {
     vue.prototype.$message.error('您当前的网络存在波动，请刷新页面或稍后重试!')
    return Promise.reject(e.message)
  })
}

const post = function (url, params) {
  const query = {
    url: url,
    method: 'post',
    withCredentials: true,
    timeout: 30000,
    data: params,
    headers: { 'Content-Type': 'application/json' }
  }
  return request(query)
}

const get = function (url, params) {
  const query = {
    url: url,
    method: 'get',
    withCredentials: true,
    timeout: 30000,
    params: params,
  }
  return request(false, query)
}

const form = function (url, params) {
  const query = {
    url: url,
    method: 'post',
    withCredentials: true,
    timeout: 30000,
    data: params,
    headers: { 'Content-Type': 'multipart/form-data'}
  }
  return request(query)
}

export {
  post,
  get,
  form
}
